import { useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

const PUBLIC_PREFIXES = ["/about", "/contact", "/p/"];

export default function WhatsAppWidget() {
  const { whatsapp } = useSettings();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Public website only — never on dashboard/terminal/wallet/admin/etc.
  const path = location.pathname;
  const isPublic = path === "/" || PUBLIC_PREFIXES.some((p) => path.startsWith(p));
  if (!isPublic) return null;
  if (!whatsapp?.enabled || !whatsapp?.number) return null;

  const num = whatsapp.number.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${num}?text=${encodeURIComponent(whatsapp.welcome_message || "Hello")}`;
  const side = whatsapp.position === "left" ? "left-5" : "right-5";
  const visibility = `${whatsapp.show_mobile ? "flex" : "hidden"} ${whatsapp.show_desktop ? "md:flex" : "md:hidden"}`;

  return (
    <div className={`fixed bottom-5 ${side} z-[60] flex-col items-end gap-3 ${visibility}`} data-testid="whatsapp-widget">
      {open && (
        <div className={`w-72 rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden ${whatsapp.position === "left" ? "self-start" : "self-end"}`} data-testid="whatsapp-panel">
          <div className="bg-[#25D366] px-4 py-3 flex items-center gap-3">
            <div className="h-9 w-9 rounded-full bg-white/20 grid place-items-center text-white"><MessageCircle className="h-5 w-5" /></div>
            <div className="text-white">
              <div className="font-semibold text-sm leading-tight">{whatsapp.display_name || "Support"}</div>
              <div className="text-[11px] opacity-90">Typically replies within minutes</div>
            </div>
          </div>
          <div className="p-4">
            <div className="rounded-lg bg-slate-100 text-slate-700 text-sm p-3 leading-relaxed">{whatsapp.welcome_message}</div>
            <a href={href} target="_blank" rel="noreferrer" data-testid="whatsapp-start-chat" className="mt-3 flex items-center justify-center gap-2 rounded-lg bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold py-2.5 text-sm transition-colors">
              <MessageCircle className="h-4 w-4" /> {whatsapp.button_text || "Chat with us"}
            </a>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="whatsapp-fab"
        aria-label="WhatsApp support"
        className="h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#20bd5a] text-white shadow-xl grid place-items-center transition-transform hover:scale-105 active:scale-95"
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-7 w-7" />}
      </button>
    </div>
  );
}
